// extracted by mini-css-extract-plugin
module.exports = {"title":"ProductBundle_title__nHeKA","list":"ProductBundle_list__QMIAL","toggle":"ProductBundle_toggle__U3nr6","summary":"ProductBundle_summary__0L2qa"};